import React from 'react'

const SvgShieldUser = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M7.783 6.826L16 5l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L16 27l-6.328-4.219A6 6 0 017 17.79V7.802a1 1 0 01.783-.976zM9 8.604v9.185a4 4 0 001.78 3.328l5.22 3.48 5.219-3.48A4 4 0 0023 17.79V8.604L16 7.05 9 8.604zM16 15a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-4.473 5a4.5 4.5 0 018.946 0h-8.946z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgShieldUser
